import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ChatbotEntry } from '../models/catalog.model';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

export interface ChatTurn {
  role: 'user' | 'assistant';
  content: string;
}

/**
 * Talks to the /api/chat Pages Function, which builds a live context from
 * the catalog and forwards the conversation to Groq's Llama 3 70B
 * Versatile model. No API key ever reaches the browser.
 */
@Injectable({ providedIn: 'root' })
export class ChatService {
  private readonly http = inject(HttpClient);
  private readonly auth = inject(AuthService);
  private readonly baseUrl = environment.apiBaseUrl;

  send(message: string, history: ChatTurn[]): Observable<{ reply: string }> {
    return this.http.post<{ reply: string }>(`${this.baseUrl}/chat`, {
      message,
      history,
    });
  }

  // ------------------------------------------------------------------
  // Admin knowledge management
  // ------------------------------------------------------------------

  adminEntries(): Observable<ChatbotEntry[]> {
    return this.http.get<ChatbotEntry[]>(`${this.baseUrl}/chatbot?all=1`, {
      headers: this.auth.authHeaders(),
    });
  }

  adminCreate(entry: Pick<ChatbotEntry, 'question' | 'answer' | 'active'>): Observable<ChatbotEntry> {
    return this.http.post<ChatbotEntry>(`${this.baseUrl}/chatbot`, entry, {
      headers: this.auth.authHeaders(),
    });
  }

  adminUpdate(
    id: number,
    entry: Pick<ChatbotEntry, 'question' | 'answer' | 'active'>
  ): Observable<ChatbotEntry> {
    return this.http.put<ChatbotEntry>(`${this.baseUrl}/chatbot/${id}`, entry, {
      headers: this.auth.authHeaders(),
    });
  }

  adminDelete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/chatbot/${id}`, {
      headers: this.auth.authHeaders(),
    });
  }
}
